import React from 'react';
import { FormComponentProps } from '../../AccountForm.meta';
import { TabWrapper } from '../../AccountForm.styles';
import { AccountDescription } from '../../components/AccountDescription/AccountDescription';
import { AccountEarmark } from '../../components/AccountEarmark/AccountEarmark';
import { AccountFees } from '../../components/AccountFees/AccountFees';
import { AccountTypeSelect } from '../../components/AccountTypeSelect/AccountTypeSelect';
import { AssetBucketing } from '../../components/AssetBucketing/AssetBucketing';
import { Balance } from '../../components/Balance/Balance';
import { BrokerOfRecord } from '../../components/BrokerOfRecord/BrokerOfRecord';
import { InheritedIRADistributionOptions } from '../../components/InheritedIRADistributionOptions/InheritedIRADistributionOptions';
import { InstitutionNameInput } from '../../components/InstitutionNameInput/InstitutionNameInput';
import { TabsContent } from '../../components/TabsContent/TabsContent';
import { ManagementStyle } from '../../components/ManagementStyle/ManagementStyle';
import { AccountNickname } from '../../components/AccountNickname/AccountNickname';
import { AccountOwnership } from '../../components/AccountOwnership/AccountOwnership';

const Summary = () => {
  return (
    <TabWrapper>
      <AccountTypeSelect />
      <InstitutionNameInput />
      <AccountOwnership />
      <AccountDescription />
      <AccountNickname />
      <Balance label="Current Market Value" />
      <AccountEarmark />
      <InheritedIRADistributionOptions />
      <BrokerOfRecord />
      <ManagementStyle />
      <AssetBucketing />
    </TabWrapper>
  );
};

const AccountDetails = () => {
  return (
    <TabWrapper>
      <AccountFees />
    </TabWrapper>
  );
};

export const InheritedIRA = (props: FormComponentProps) => {
  return (
    <TabsContent
      {...props}
      tabs={[
        { name: 'Summary', Component: Summary },
        { name: 'Account Details', Component: AccountDetails },
      ]}
    />
  );
};
